import {PayloadAction} from "@reduxjs/toolkit";


export const setter = <S, F extends keyof S>(initialState: S, field: F) => (state: S, action?: PayloadAction<S[F]>) => {
  state[field] = action ? action.payload : initialState[field]
};

export const unsetter = <S, F extends keyof S>(field: F) => (state: S) => {
  delete(state[field])
};